import { h, Component } from 'preact';
import {Form, Container, Row, Col, I18n} from 'components/elements' 
import {connect} from 'react-redux'
import style from './style.less'
import dayjs from 'lib/helpers/dayjs';
import {FAChevronUp, FAChevronDown, FASpinner} from 'components/elements/FontAwesome'
import iconChevronDown from '../../../assets/icons/svg/chevron_down.svg'
import iconChevronUp from '../../../assets/icons/svg/chevron_up.svg'

@Form
@connect((state)=>({
	...state
}))
export default class OperatingHours extends Component {
	constructor(){
        super()
        this.state = {
            showHours: false
        }
        
        this.condensedTimes = this.condensedTimes.bind(this)
        this.toggleShowMore = this.toggleShowMore.bind(this)
    }

    get hours(){
        return this.props.hours || []
    }

    get isOpen(){
        let now = dayjs()
        for(let hour of this.hours){
            if(hour.startsAt.isBefore(now) && hour.endsAt.isAfter(now)){
                return true
            }
        }
        return false
    }

    get closeTime(){
        let now = dayjs()
        for(let hour of this.hours){
            if(hour.startsAt.isBefore(now) && hour.endsAt.isAfter(now)){
                return hour.endsAt.format("h:mm A")
            }
        }
        return ''
    }
    
    get nextOpenTime(){
        let now = dayjs()
        for(let hour of this.hours){
            if(hour.startsAt.isAfter(now)){
                return `opens on ${hour.startsAt.format("ddd")} at ${hour.startsAt.format("h:mm A")}`
            }
        }
        return ''
    }

    condensedTimes(_times, returnTimeByDay = false){
        let days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
        let timesByDay = {}
        for(let time of _times){
            let day = dayjs(time.startsAt).format('ddd')
            let startsAt = dayjs(time.startsAt).format("h:mm A")
            let endsAt = dayjs(time.endsAt).format("h:mm A")
            if(!timesByDay[day]){
                timesByDay[day] = {}
                timesByDay[day].times = [time]
                timesByDay[day].quickTime = `${startsAt}-${endsAt}`
            } else {
                timesByDay[day].times.push(time)
                timesByDay[day].quickTime += `||${startsAt}-${endsAt}`
            }
        }

        if(returnTimeByDay){
            days.forEach((day)=>{
                if(!timesByDay[day]){
                    timesByDay[day] = {time: [], quickTime: ''}
                }
            });

            return timesByDay
        } 

        let times = []
        
        for(let [i,day] of days.entries()){
            if(timesByDay[day]){
                if(!timesByDay[days[i-1]] || timesByDay[day].quickTime != timesByDay[days[i-1]].quickTime || times.length == 0){
                    times.push({
                        days: [day],
                        hours: [...timesByDay[day].times.map((t)=>{
                            return {
                                startsAt: dayjs(t.startsAt).format("h:mm A"),
                                endsAt: dayjs(t.endsAt).format("h:mm A")
                            }
                        })]
                    })
                } else {
                    let previousTime = times[times.length - 1]
                    previousTime.days.push(day)
                }
            }
        }
        return times
    }

    toggleShowMore(e){
        e.preventDefault()
        this.setState({
            showHours: !this.state.showHours
        })
    }

	render(){
        const today = dayjs().format('ddd');
        const isOpen = !this.props.forceClose && this.isOpen;
        const schedule = this.condensedTimes(this.hours, true);
		return (
            <div>
                <Container class={style.hoursContainer}>
                    <div class={style.hoursHeader}>
                        <div className={style.details}>
                            <span className={isOpen ? style.openTag : style.closeTag }>
                                {
                                    isOpen
                                    ?  <I18n>open</I18n>
                                    :  <I18n>closed</I18n>
                                }
                            </span>
                            <span>
                                {this.props.header}
                            </span>
                            <span class={style.subHeader}>
                                {
                                    isOpen
                                    ? `${I18n.t("closesAt")} ${this.closeTime}`
                                    : `${this.nextOpenTime}`
                                }
                            </span>
                        </div>
                        <div className={style.actions}>
                            {this.state.showHours ? 
                                <div class={style.showMore} onClick={this.toggleShowMore}>
                                    <img src={iconChevronUp} alt='chevron up icon'/>
                                </div>
                            :
                            <div class={style.showMore} onClick={this.toggleShowMore}>
                                    <img src={iconChevronDown} alt='chevron down icon'/>
                                </div>
                            }
                        </div>
                    </div>
                    {this.state.showHours && (
                            <div className={style.schedules}> 
                                {
                                    Object.keys(schedule).map((day)=>(
                                        <Row class={`${style.schedule} ${day === today ? style.isToday : ""}`}>
                                            <Col>{day}</Col>
                                            <Col>{schedule[day] && schedule[day].quickTime || I18n.t("closed")}</Col>
                                        </Row>
                                    ))
                                }
                            </div>
                            
                        )
                    }
                </Container>
            </div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/groups/OperatingHours/index.js